// import Grid from '@mui/material/Grid';
import {useEffect, useMemo, useState} from 'react';

import Button from '@mui/material/Button';

import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

import {ignoreTextFieldKeys, getRegexpDescription} from "ultra/helpers/utils";

import {useFormStore} from '../../../Stores/form';

import './index.scss';

export default function List(props) {
    const {content, disabled, field, hideErrors, isEditMode, onChange, onFocus, onBlur} = props;
    const [isDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))

    const [list, setList] = useState(content[field.id] || [''])

    const {formVisibleErrors, clearFormError} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [regexpHighlight, setRegexpHighlight] = useState(false)

    const [addMoreItemClass, setAddMoreItemClass] = useState('addMore');
    const [pseudoInputClass, setPseudoInputClass] = useState('pseudoInput');

    useEffect(() => {
        if (list[list.length - 1].length === 0) {
            setAddMoreItemClass('addMore disabled')
        }
        else {
            setAddMoreItemClass('addMore')
        }
    }, [list])

    useEffect(() => {
        if (showErrorText || regexpHighlight) {
            setPseudoInputClass('pseudoInput error')
        }
        else {
            setPseudoInputClass('pseudoInput')
        }
    }, [showErrorText, regexpHighlight])

    useEffect(() => {
        if (!content[field.id] || content[field.id].length === 0) {
            setList([''])
        }
        else {
            setList(content[field.id])
        }
    }, [content[field.id]])

    const formatedRegexp = useMemo(() => {
        if (!field?.options?.regexp) return "";        
        return "Доступні для вводу символи: " + getRegexpDescription(field.options.regexp);
    }, [field?.options?.regexp])

    const onFirstItemChange = (e) => {
        const value = [...list];
        value[0] = e.target.value;
        setList(value);
        onChange({target: {value}})
    }

    const onItemChange = (index, e) => {
        const value = [...list];
        value[index] = e?.target?.value;
        setList(value);
        onChange({target: {value}});
    }

    const onItemRemove = (i) => {
        const value = [...list];
        value.splice(i, 1);
        setList(value);
        onChange({target: {value}});
    }

    const onItemAdd = () => {
        clearFormError(field.id);
        setRegexpHighlight(false);

        const value = [...list];
        if (!value?.[0]) return;
        // onChange({target: {value}});    // set existing value to clean errors

        value.push('');
        setList(value);
    }

    const onBlurHandler = (e) => {
        if (onBlur) onBlur({
            target: {
                value: list
            }
        });
        setRegexpHighlight(false);

        // if (fieldErrorCheck) fieldErrorCheck(e);
    }

    const onPasteHandler = (e) => {
        if (field?.options?.regexp) {
            const regex = new RegExp(field.options.regexp);
            const pastedData = (e.clipboardData || window.clipboardData).getData('text');
            if (!regex.test(pastedData)) {
                setRegexpHighlight(true);
                e.preventDefault();
            }
        }

        // if (fieldErrorCheck) fieldErrorCheck(e);
    }

    const onKeyDownHandler = (e) => {
        if (!field?.options?.regexp) return false;
        const regex = new RegExp(field.options.regexp);

        if (((e.ctrlKey || e.metaKey) && e.key === 'v') || e.key === 'Enter') {
            if (!ignoreTextFieldKeys(e) && !regex.test(e?.target?.value)) {
                setRegexpHighlight(true);
            }
            else {
                setRegexpHighlight(false);
            }

            return false;
        }

        if (!ignoreTextFieldKeys(e) && !regex.test(e.key)) {
            e.preventDefault();
            setRegexpHighlight(true);
        }
        else {
            setRegexpHighlight(false);
        }

        // if (fieldErrorCheck) fieldErrorCheck(e);
    }

    return <div className="ListField">
        <div className={pseudoInputClass}>
            {field?.placeholder && <div className='inputLabel'>{field?.placeholder}</div>}
            <div className="ListFieldItem">
                {/* <TextFieldInput
                    {...props}
                    onChange={onFirstItemChange}
                    disabled={isDisabled}
                    value={(content[field.id] || [])[0] || ''}
                /> */}
                <TextField
                    // error={Boolean(!regexpHighlight && !hideErrors && showErrorText)}
                    // helperText={!regexpHighlight && !hideErrors && showErrorText}
                    fullWidth
                    value={list[0] || ''}
                    required={field?.required}
                    // label={field?.placeholder}
                    variant="outlined"
                    onKeyDown={onKeyDownHandler}
                    onChange={onFirstItemChange}
                    onFocus={onFocus}
                    onBlur={onBlurHandler}
                    onPaste={onPasteHandler}
                    disabled={isDisabled}
                    // inputProps={{
                    //     maxLength: field?.options?.maxLength,
                    //     inputMode: inputMode,
                    // }}
                    // InputProps={InputProps}
                />
            </div>

            {list?.length > 1 && list.slice(1).map((item, index) => {
                return <div key={'list_field_item_' + index} className="ListFieldItem">
                    <TextField
                        // error={Boolean(!regexpHighlight && !hideErrors && showErrorText)}
                        // helperText={!regexpHighlight && !hideErrors && showErrorText}
                        fullWidth
                        value={item}
                        required={field?.required}
                        // label={field?.placeholder}
                        variant="outlined"
                        onKeyDown={onKeyDownHandler}
                        onChange={(e) => onItemChange(index + 1, e)}
                        onFocus={onFocus}
                        onBlur={onBlurHandler}
                        onPaste={onPasteHandler}
                        disabled={isDisabled}
                        // inputProps={{
                        //     maxLength: field?.options?.maxLength,
                        //     inputMode: inputMode,
                        // }}
                        // InputProps={InputProps}
                    />

                    <Button
                        className="action"
                        variant="contained"
                        component="label"
                        tabIndex={-1}
                        onClick={() => onItemRemove(index + 1)}>
                            <CloseIcon />
                    </Button>
                </div>
            })}

            {regexpHighlight && field?.options?.regexp && <div className={regexpHighlight ? "fieldNotes fieldNotesRegexpError" : "fieldNotes"}>
                <p>{formatedRegexp}</p>
            </div>}

            <div className='addMoreWrapper'>
                <span className={addMoreItemClass} onClick={onItemAdd}>
                    <AddIcon /> <span className='pseudoLink'>{field?.options?.addPlaceholder || 'Додати ще'}</span>
                </span>
            </div>
        </div>
    </div>
}
